// The Assistant's URL state (app-feel plan, builder B, 2026-10-01).
//
// `?tab=` · `&sub=` · `&view=` · `&chat=` — the place lives in the URL, so a
// link in a note or a notification opens it, and Back (the button, or the
// shell's left-edge swipe) walks it like a native app.
//
// ⚠️ OPENING A CHAT FROM THE LIST PUSHES, with `{ chatFromList: true }` in the
// history state. Closing it then POPS — so the back arrow, the browser's Back
// and the swipe-back all land on the same list. A chat opened from a link or a
// notification has no list under it: closing REPLACES, never leaving the app.

export function tabParams(tab: string, extra: Record<string, string> = {}): URLSearchParams {
  const p = new URLSearchParams();
  p.set('tab', tab);
  for (const [k, v] of Object.entries(extra)) p.set(k, v);
  return p;
}

export function withChat(current: URLSearchParams, chatId: string): URLSearchParams {
  const p = new URLSearchParams(current);
  p.set('tab', 'conversations');
  p.set('chat', chatId);
  return p;
}

export function withoutChat(current: URLSearchParams): URLSearchParams {
  const p = new URLSearchParams(current);
  p.delete('chat');
  return p;
}

/** The history state a chat opened from the list carries. */
export const CHAT_FROM_LIST = { chatFromList: true } as const;

export function closeChatMove(state: unknown): 'pop' | 'replace' {
  return state && typeof state === 'object' && (state as { chatFromList?: unknown }).chatFromList === true ? 'pop' : 'replace';
}

/** Relances now live in Automatisations ▸ Relances; the old page's URL lands on its list. */
export const MANUAL_REMINDERS = { tab: 'automations', sub: 'followups', view: 'manual' } as const;

export function followUpRedirect(search: string): string {
  const incoming = new URLSearchParams(search);
  const p = tabParams(MANUAL_REMINDERS.tab, { sub: MANUAL_REMINDERS.sub, view: MANUAL_REMINDERS.view });
  for (const [k, v] of incoming) {
    if (k === 'tab' || k === 'sub' || k === 'view') continue;
    p.append(k, v);
  }
  return `/admin/assistant?${p.toString()}`;
}
